

<template>
  <v-container fluid>
    <isrs-parcel-number-container :value="parcelNumberContainerItem"/>
  </v-container>
</template>

<script>
  import IsrsParcelNumberContainer from '../components/IsrsParcelNumberContainer.vue'

  export default {
    components: {IsrsParcelNumberContainer},

    data() {
      return {
        parcelNumberContainerItem : {}
      }
    },
    created() {
      console.log(this.$route.params.id);
      this.dataService.getParcelNumberContainer(this.$route.params.id).then(result => {
        console.log('getParcelNumberContainer ' , result.data);
        this.parcelNumberContainerItem = result.data;
      });
    }
  }

</script>



// WEBPACK FOOTER //
// GetParcelNumberContainer.vue?cea38222